import React, { useState } from 'react'
import api from '../../api-client'
import { toast } from 'react-toastify'
import { errorToString } from '@oneethos/shared'

type CreateWebhookFormProps = {
  onWebhookCreated: () => void
}

export const CreateWebhookForm = ({ onWebhookCreated }: CreateWebhookFormProps) => {
  const [notificationUrl, setNotificationUrl] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!notificationUrl) {
      toast.error('Notification URL is required')
      return
    }

    setIsSubmitting(true)
    try {
      await api.post('/tenant/airtable-webhooks', {
        notificationUrl
      })
      toast.success('Webhook created successfully')
      setNotificationUrl('')
      onWebhookCreated()
    } catch (ex) {
      toast.error(errorToString(ex))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="card mb-3">
      <div className="card-header">
        <h5>Create New Webhook</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="notificationUrl">Notification URL</label>
            <input
              id="notificationUrl"
              type="url"
              className="form-control"
              value={notificationUrl}
              onChange={(e) => setNotificationUrl(e.target.value)}
              placeholder="https://example.com/webhook"
              required
            />
            <small className="form-text text-muted">
              The URL where Airtable will send webhook notifications. The specification will automatically be set to filter tableData events.
            </small>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Create Webhook'}
          </button>
        </form>
      </div>
    </div>
  )
}

